import { AuthContext } from "providers/AuthProvider";
import { useContext } from "react";

// Custom hook that shorthands the auth context!
export const useAuth = () => useContext(AuthContext);

export default useAuth;
